export const errors = {
  not_found: {
    title: 'Nicht gefunden!',
    description: 'Diese Seite konnte nicht gefunden werden',
    action: 'Zurück zur Startseite',
  },
}
